import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {FONT_WEIGHT_PROXIMA_SEMIBOLD, FONT_PROXIMA_15} from 'styles/FontConstants';
import {GRAY_DARK, GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Pane from 'ui-library/pane/Pane';

import {SharedUniversalBlockViewProps} from './SharedUniversalBlockViewTypes';

export interface ErrorUniversalBlockViewProps extends SharedUniversalBlockViewProps {
  errorMessage: ReactNode;
}

/**
 * Presentational component of a Universal Block that shows an error
 *
 * If the caller is using `PresentationalUniversalBlockView` with data that can potentially have an error state,
 * then it can use this component to show the error state.
 *
 * This component applies text styling to the errorMessage's content, so callers only need to define the html
 * content.
 */
export default function ErrorUniversalBlockView({
  errorMessage,
  paneProps,
}: ErrorUniversalBlockViewProps): JSX.Element {
  return (
    <Pane {...paneProps} centerContent={true}>
      <BenchlingIcon
        icon="warning"
        className={css(styles.icon)}
        dataTestAttrs={{
          ...paneProps.dataTestAttrs,
          component: paneProps.dataTestAttrs?.component ?? 'ErrorUniversalBlockView',
          element: 'errorIcon',
        }}
      />
      <div className={css(styles.errorText)}>{errorMessage}</div>
    </Pane>
  );
}

const styles = StyleSheet.create({
  icon: {
    color: GRAY_LIGHT,
    height: '60px',
    width: '60px',
  },
  errorText: {
    ...FONT_PROXIMA_15,
    color: GRAY_DARK,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
});
